import React, { Component } from 'react';
import MachineQuotationListView from '../views/MachineQuotationListView';
import { base } from '../../base';

class MachineQuotationListContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            quotations: [],
        };
    }

    componentWillMount() {
        this.valuesRef = base.syncState(`quotations/${this.props.extraUser.companyid}`, {
            context: this,
            asArray: true,
            state: 'quotations',
            queries: {
                orderByChild: 'machineid',
                equalTo: this.props.machineId,
            },
        });
    }

    componentWillUnmount() {
        base.removeBinding(this.valuesRef);
    }

    render() {
        console.log(this.state.quotations);
        return (
            <MachineQuotationListView
                quotations={this.state.quotations}
            />
        );
    }
}

export default MachineQuotationListContainer;



// WEBPACK FOOTER //
// ./src/components/containers/MachineQuotationListContainer.js